import * as React from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import { connect } from 'react-redux';
import { TranslateProps } from 'util/i18n';
import { OemProps } from 'ui/styles/skin';
import { DeviceIndex, Camera } from 'types';
import { State } from 'reducers';
import { getCameraByDeviceIndex } from 'selectors/deviceSelectors';
import { X } from 'ui/shapes';
import { Button } from 'ui/shared/Button';


export type OwnProps = OemProps & TranslateProps & {
    id: string;
    deviceIndex: DeviceIndex;
    onRemove: () => void;
};

const RawSelectedCamera = ({
    id,
    deviceIndex,
    onRemove,
    camera,
    t,
    deviceIndexStyle,
    separatorStyle,
    cameraNameStyle,
    xStyle,
}: OwnProps & StateProps & RecomposeProps) =>
    <div>
        <span style={ deviceIndexStyle }>
            { deviceIndex }
        </span>
        <span style={ separatorStyle }>)</span>
        <span style={ cameraNameStyle }>
            { camera
                ? camera.name
                : t('6.1237.3262')
            }
        </span>
        <Button id={ `${id}-remove` } type="button" className="small" onClick={ onRemove } title={ t('BTN_REMOVE') }>
            <X width=".8em" height=".8em" style={ xStyle }/>
        </Button>
    </div>
;

type StateProps = {
    camera: Camera | null;
};
type RecomposeProps = {
    deviceIndexStyle: {};
    separatorStyle: {};
    cameraNameStyle: {};
    xStyle: {};
};

const mapStateToProps = (state: State, props: OwnProps) => ({
    camera: getCameraByDeviceIndex(state, props),
});

export const SelectedCamera = compose<OwnProps & StateProps & RecomposeProps, OwnProps>(
    setDisplayName('SelectedCamera'),
    connect<StateProps, void, {}>(mapStateToProps),
    withProps(({ styles }: OemProps ) => ({
        deviceIndexStyle: {
            opacity: .75,
        },
        separatorStyle: {
            opacity: .25,
        },
        cameraNameStyle: {
            margin: '0 .5em',
        },
        xStyle: {
            fill: styles.Button.color,
        },
    })),
)(RawSelectedCamera);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/cameras/SelectedCamera.tsx